import { User } from 'store/user/types';
import qs from 'qs';

export const getMicroFrontendParams = (
  user: User,
  apiUrl: string,
  authToken: string,
  buildingUuid: string,
  cartId: string,
  locale?: string,
) => {
  const miniAppProps = {
    cartId,
    buildingUuid,
    authToken: `${authToken}`,
    firstName: user.first_name,
    lastName: user.last_name,
    userId: user.id,
    userUuid: user.uuid,
    apiUrl,
    locale,
  };

  return qs.stringify(miniAppProps);
};
